const siteNavItems = document.querySelectorAll('.is-top-level > .has-children');
if (siteNavItems) {
  [].forEach.call(siteNavItems, (siteNavItem) => siteNavItem.addEventListener('mouseover', toggleSubmenu));
  [].forEach.call(siteNavItems, (siteNavItem) => siteNavItem.addEventListener('mouseout', toggleSubmenu));
}

// Toggle first level submenu.
function toggleSubmenu(event) {
  event.preventDefault();

  const siteNavLink = event.currentTarget.querySelector('.js-block-header__link');
  if (!siteNavLink) return;

  const siteNavItem = siteNavLink.parentNode;
  const isSiteNavItemActive = siteNavItem.classList.contains('is-active');

  const currentSubmenu = siteNavLink.nextElementSibling;
  if (currentSubmenu) {
    const isSubmenuOpen = currentSubmenu.classList.contains('is-open');

    // Reset state for all submenus.
    [].forEach.call(document.querySelectorAll('.js-block-header__submenu'), (submenu) => submenu.classList.remove('is-open'));

    // Set current submenu active.
    currentSubmenu.classList.toggle('is-open', !isSubmenuOpen);

    // Reset state for all links and items.
    [].forEach.call(document.querySelectorAll('.is-top-level > li > .js-block-header__link'), (siteNavLink) => {
      siteNavLink.classList.remove('is-active');
      siteNavLink.setAttribute('aria-expanded', 'false');
      siteNavLink.parentNode.classList.remove('is-active')
    });

    // Set current link and item active.
    siteNavLink.setAttribute('aria-expanded', isSubmenuOpen ? 'false' : 'true');
    siteNavItem.classList.toggle('is-active', !isSiteNavItemActive);
  }
}

const secondLvlLinks = document.querySelectorAll('.is-2nd-level .js-block-header__link');
if (secondLvlLinks) {
  [].forEach.call(secondLvlLinks, (secondLvlLink) => secondLvlLink.addEventListener('mouseover', subMenuPreview));
}

function subMenuPreview(event) {
  const secondLvlLink = event.target;
  const submenu = secondLvlLink.parentNode.parentNode.parentNode;
  const previewTitle = submenu.querySelector('.js-block-header__preview-title');
  const previewImage = submenu.querySelector('.js-block-header__preview-img');

  if (secondLvlLink.dataset.image && secondLvlLink.dataset.image !== previewImage.src) {
    previewImage.classList.add('is-transitioning');

    setTimeout(() => {
      previewImage.src = secondLvlLink.dataset.image;
      previewImage.classList.remove('is-transitioning');
    }, 200);
  }

  if (previewTitle?.innerText) {
    previewTitle.innerText = secondLvlLink.innerText.replace(/(\r\n|\n|\r)/gm, "");
  }
}